import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Guides.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function GuidesSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [purchase, setPurchase] = useState(null);

  useEffect(() => {
    const verifyPurchase = async () => {
      if (!sessionId) {
        setError('No session ID provided');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/guides/verify-session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId })
        });

        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.message || 'Failed to verify purchase');
        }

        const data = await response.json();
        setPurchase(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    verifyPurchase();
  }, [sessionId]);

  if (loading) {
    return (
      <div className="guides-page">
        <div className="guides-loading container">
          <div className="loading-spinner"></div>
          <p>Verifying your purchase...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="guides-page">
        <Helmet>
          <title>Purchase Error | PrivateSold</title>
        </Helmet>
        <div className="guides-success container">
          <div className="success-card error">
            <div className="success-icon error">✕</div>
            <h1>Something Went Wrong</h1>
            <p>{error}</p>
            <p className="help-text">
              If you were charged but don't see your guide, please contact us at{' '}
              <a href="mailto:support@privatesold.com">support@privatesold.com</a>
            </p>
            <Link to="/blog" className="btn-primary">Back to Blog</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="guides-page">
      <Helmet>
        <title>Purchase Complete | PrivateSold</title>
      </Helmet>
      
      <div className="guides-success container">
        <div className="success-card">
          <div className="success-icon">✓</div>
          <h1>Thank You for Your Purchase!</h1>
          <p className="guide-title">{purchase?.guideTitle}</p>
          
          <div className="download-section">
            <a 
              href={`${API_URL}/guides/download/${purchase?.downloadToken}`}
              className="btn-primary download-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              📥 Download Your PDF
            </a>
            <p className="download-note">
              A download link has also been sent to your email
            </p>
          </div>
          
          <div className="next-steps">
            <h3>What's Next?</h3>
            <ul>
              <li>Download and save your PDF for offline access</li>
              <li>Check your email for the download link (save it for later)</li>
              <li>You can re-download anytime using your email</li>
            </ul>
          </div>
          
          <div className="action-buttons">
            <Link to={`/blog/${purchase?.guideSlug}`} className="btn-secondary">
              Read the Article
            </Link>
            <Link to="/blog" className="btn-outline">
              Browse More Articles
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuidesSuccess;
